export const environment = {
  production: false,
  apiUrl: 'https://dev.dwall.online/api',
  stripeApiUrl: 'https://dev.cashier.dwall.online/api/v1/user/stripe',
  cashierUrl: 'https://dev.cashier.dwall.online/api/v1/user',
  stripeKey: 'pk_test_WC9ehAd0qpY1PftUeUUncCwu00PIKWPu5e',
  hmr: false,
  type: 'dev',
  landingUrl: 'https://dev.dwall.online',
  theme: 'default',
  featureToggle: {
    subscription: true,
    marketplace: true,
    security: true,
    userManagement: true
  }
};
